import axios from "axios";
import { BASE_URL } from "App/constants";

export interface CoachPromotionalOfferPayload {
  coach_id: number;
  video_count: number;
  review_rates: { INR: number; USD: number };
}

export const createCoachPromotionalOffer = async (
  assetId: number,
  payload: CoachPromotionalOfferPayload
) => {
  const { data } = await axios.post(
    `${BASE_URL}assets/${assetId}/coach_promotional_offers`,
    { coach_promotional_offer: payload }
  );
  return data;
};

export const updateCoachPromotionalOffer = async (
  assetId: number,
  offerId: number,
  payload: Partial<CoachPromotionalOfferPayload>
) => {
  const { data } = await axios.patch(
    `${BASE_URL}assets/${assetId}/coach_promotional_offers/${offerId}`,
    { coach_promotional_offer: payload }
  );
  return data;
};

export const deleteCoachPromotionalOffer = async (
  assetId: number,
  offerId: number
) => {
  const { data } = await axios.delete(
    `${BASE_URL}assets/${assetId}/coach_promotional_offers/${offerId}`
  );
  return data;
};
